export const PATH_KNOWLEDGE = '/knowledge';
export const PATH_KNOWLEDGE_ARTICLE = '/knowledge/:article';
